import { inject, Injectable } from '@angular/core';
import { OSKHttpsSuccessResponse } from '@oskey/core';
import { OSKDocumentList } from '@oskey/core/types';
import { OSKFirebaseHttpsService } from '@oskey/firebase';
import { OSKCreateEntity, OSKEntity } from '../types/organization-entity.type';

@Injectable({
  providedIn: 'root'
})
export class OSKOrganizationEntitiesService {
  private readonly firebaseHttps: OSKFirebaseHttpsService = inject(OSKFirebaseHttpsService);

  public createEntity(entity: OSKCreateEntity): Promise<OSKHttpsSuccessResponse<OSKEntity>> {
    return this.firebaseHttps.call<OSKCreateEntity, OSKEntity>('organization-createEntity', entity);
  }

  public getEntityById(
    organizationId: string,
    entityId: string
  ): Promise<OSKHttpsSuccessResponse<OSKEntity>> {
    return this.firebaseHttps.call<{ organizationId: string; entityId: string }, OSKEntity>(
      'organization-getEntityById',
      { organizationId, entityId }
    );
  }

  public getAllEntities(
    organizationId: string,
    entityId?: string
  ): Promise<OSKHttpsSuccessResponse<OSKDocumentList<OSKEntity>>> {
    const params: { organizationId: string; entityId?: string } = { organizationId };
    if (entityId) {
      params.entityId = entityId;
    }
    return this.firebaseHttps.call<
      { organizationId: string; entityId?: string },
      OSKDocumentList<OSKEntity>
    >('organization-getAllEntities', params);
  }

  public updateEntity(
    organizationId: string,
    entityId: string,
    update: Partial<OSKEntity>
  ): Promise<OSKHttpsSuccessResponse<OSKEntity>> {
    return this.firebaseHttps.call<
      { organizationId: string; entityId: string; update: Partial<OSKEntity> },
      OSKEntity
    >('organization-updateEntity', { organizationId, entityId, update });
  }

  public deleteEntity(
    organizationId: string,
    entityId: string
  ): Promise<OSKHttpsSuccessResponse<void>> {
    return this.firebaseHttps.call<{ organizationId: string; entityId: string }, void>(
      'organization-deleteEntity',
      {
        organizationId,
        entityId
      }
    );
  }
}
